import { combineReducers } from "redux";
import {
    BOOKING_PAGE_ERROR,
    BOOKING_PAGE_LOADING,
    BOOKING_PAGE_SUCCESS,
    BOOKING_SAVE_ERROR,
    BOOKING_SAVE_LOADING,
    BOOKING_SAVE_SUCCESS,
    BOOKING_VIEW_ERROR,
    BOOKING_VIEW_LOADING,
    BOOKING_VIEW_SUCCESS,
    BOOKING_REJECT_ERROR,
    BOOKING_REJECT_LOADING,
    BOOKING_REJECT_SUCCESS,
    BOOKING_APPROVE_ERROR,
    BOOKING_APPROVE_LOADING,
    BOOKING_APPROVE_SUCCESS,
    BOOKING_REJECT_DISNAK_ERROR,
    BOOKING_REJECT_DISNAK_LOADING,
    BOOKING_REJECT_DISNAK_SUCCESS,
    BOOKING_APPROVE_DISNAK_ERROR,
    BOOKING_APPROVE_DISNAK_LOADING,
    BOOKING_APPROVE_DISNAK_SUCCESS,
    BOOKING_PAYMENT_CONFIRMATION_ERROR,
    BOOKING_PAYMENT_CONFIRMATION_LOADING,
    BOOKING_PAYMENT_CONFIRMATION_SUCCESS,
    BOOKING_PAYMENT_VALIDATION_ERROR,
    BOOKING_PAYMENT_VALIDATION_LOADING,
    BOOKING_PAYMENT_VALIDATION_SUCCESS,
    BOOKING_RO_ERROR,
    BOOKING_RO_LOADING,
    BOOKING_RO_SUCCESS,
    BOOKING_SI_ERROR,
    BOOKING_SI_LOADING,
    BOOKING_SI_SUCCESS,
    BOOKING_GENERATE_BL_ERROR,
    BOOKING_GENERATE_BL_LOADING,
    BOOKING_GENERATE_BL_SUCCESS,
    BOOKING_BL_ERROR,
    BOOKING_BL_LOADING,
    BOOKING_BL_SUCCESS,
    BOOKING_GOODS_TAKER_ERROR,
    BOOKING_GOODS_TAKER_LOADING,
    BOOKING_GOODS_TAKER_SUCCESS,
    BOOKING_STATUS_ERROR,
    BOOKING_STATUS_LOADING,
    BOOKING_STATUS_SUCCESS,
    STATUS_ORDER_ERROR,
    STATUS_ORDER_LOADING,
    STATUS_ORDER_SUCCESS,
    BOOKING_LIST_SUCCESS,
    BOOKING_LIST_ERROR,
    BOOKING_LIST_LOADING,
    CHANGE_STATUS_BOOKING_LOADING,
    CHANGE_STATUS_BOOKING_SUCCESS,
    CHANGE_STATUS_BOOKING_ERROR,
} from "./constant";

const bookingPageError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PAGE_ERROR:
            return action.bookingPageError;
        default:
            return state;
    }
};

const bookingPageLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PAGE_LOADING:
            return action.bookingPageLoading;
        default:
            return state;
    }
};

const bookingPageSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PAGE_SUCCESS:
            return action.bookingPageSuccess;
        default:
            return state;
    }
};

const bookings = (state = [], action) => {
    switch (action.type) {
        case BOOKING_PAGE_SUCCESS:
            return action.booking;
        case BOOKING_LIST_SUCCESS:
            return action.booking;
        default:
            return state;
    }
};

const booking = (state = [], action) => {
    switch (action.type) {
        case BOOKING_VIEW_SUCCESS:
            return action.booking;
        case BOOKING_RO_SUCCESS:
            return action.booking;
        case BOOKING_SI_SUCCESS:
            return action.booking;
        case BOOKING_BL_SUCCESS:
            return action.booking;
        default:
            return state;
    }
};

const bookingSaveError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_SAVE_ERROR:
            return action.bookingSaveError;
        default:
            return state;
    }
};

const bookingSaveLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_SAVE_LOADING:
            return action.bookingSaveLoading;
        default:
            return state;
    }
};

const bookingSaveSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_SAVE_SUCCESS:
            return action.bookingSaveSuccess;
        default:
            return state;
    }
};

const bookingViewError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_VIEW_ERROR:
            return action.bookingViewError;
        default:
            return state;
    }
};

const bookingViewLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_VIEW_LOADING:
            return action.bookingViewLoading;
        default:
            return state;
    }
};

const bookingViewSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_VIEW_SUCCESS:
            return action.bookingViewSuccess;
        default:
            return state;
    }
};

const bookingRejectError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_REJECT_ERROR:
            return action.bookingRejectError;
        default:
            return state;
    }
};

const bookingRejectLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_REJECT_LOADING:
            return action.bookingRejectLoading;
        default:
            return state;
    }
};

const bookingRejectSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_REJECT_SUCCESS:
            return action.bookingRejectSuccess;
        default:
            return state;
    }
};

const bookingApproveError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_APPROVE_ERROR:
            return action.bookingApproveError;
        default:
            return state;
    }
};

const bookingApproveLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_APPROVE_LOADING:
            return action.bookingApproveLoading;
        default:
            return state;
    }
};

const bookingApproveSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_APPROVE_SUCCESS:
            return action.bookingApproveSuccess;
        default:
            return state;
    }
};

const bookingRejectDisnakError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_REJECT_DISNAK_ERROR:
            return action.bookingRejectDisnakError;
        default:
            return state;
    }
};

const bookingRejectDisnakLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_REJECT_DISNAK_LOADING:
            return action.bookingRejectDisnakLoading;
        default:
            return state;
    }
};

const bookingRejectDisnakSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_REJECT_DISNAK_SUCCESS:
            return action.bookingRejectDisnakSuccess;
        default:
            return state;
    }
};

const bookingApproveDisnakError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_APPROVE_DISNAK_ERROR:
            return action.bookingApproveDisnakError;
        default:
            return state;
    }
};

const bookingApproveDisnakLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_APPROVE_DISNAK_LOADING:
            return action.bookingApproveDisnakLoading;
        default:
            return state;
    }
};

const bookingApproveDisnakSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_APPROVE_DISNAK_SUCCESS:
            return action.bookingApproveDisnakSuccess;
        default:
            return state;
    }
};

const bookingPaymentConfirmationError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PAYMENT_CONFIRMATION_ERROR:
            return action.bookingPaymentConfirmationError;
        default:
            return state;
    }
};

const bookingPaymentConfirmationLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PAYMENT_CONFIRMATION_LOADING:
            return action.bookingPaymentConfirmationLoading;
        default:
            return state;
    }
};

const bookingPaymentConfirmationSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PAYMENT_CONFIRMATION_SUCCESS:
            return action.bookingPaymentConfirmationSuccess;
        default:
            return state;
    }
};

const bookingPaymentValidationError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PAYMENT_VALIDATION_ERROR:
            return action.bookingPaymentValidationError;
        default:
            return state;
    }
};

const bookingPaymentValidationLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PAYMENT_VALIDATION_LOADING:
            return action.bookingPaymentValidationLoading;
        default:
            return state;
    }
};

const bookingPaymentValidationSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PAYMENT_VALIDATION_SUCCESS:
            return action.bookingPaymentValidationSuccess;
        default:
            return state;
    }
};

const bookingROError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_RO_ERROR:
            return action.bookingROError;
        default:
            return state;
    }
};

const bookingROLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_RO_LOADING:
            return action.bookingROLoading;
        default:
            return state;
    }
};

const bookingROSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_RO_SUCCESS:
            return action.bookingROSuccess;
        default:
            return state;
    }
};

const bookingSIError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_SI_ERROR:
            return action.bookingSIError;
        default:
            return state;
    }
};

const bookingSILoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_SI_LOADING:
            return action.bookingSILoading;
        default:
            return state;
    }
};

const bookingSISuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_SI_SUCCESS:
            return action.bookingSISuccess;
        default:
            return state;
    }
};

const bookingGenerateBLError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_GENERATE_BL_ERROR:
            return action.bookingGenerateBLError;
        default:
            return state;
    }
};

const bookingGenerateBLLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_GENERATE_BL_LOADING:
            return action.bookingGenerateBLLoading;
        default:
            return state;
    }
};

const bookingGenerateBLSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_GENERATE_BL_SUCCESS:
            return action.bookingGenerateBLSuccess;
        default:
            return state;
    }
};

const bookingBLError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_BL_ERROR:
            return action.bookingBLError;
        default:
            return state;
    }
};

const bookingBLLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_BL_LOADING:
            return action.bookingBLLoading;
        default:
            return state;
    }
};

const bookingBLSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_BL_SUCCESS:
            return action.bookingBLSuccess;
        default:
            return state;
    }
};

const bookingGoodsTakerError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_GOODS_TAKER_ERROR:
            return action.bookingGoodsTakerError;
        default:
            return state;
    }
};

const bookingGoodsTakerLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_GOODS_TAKER_LOADING:
            return action.bookingGoodsTakerLoading;
        default:
            return state;
    }
};

const bookingGoodsTakerSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_GOODS_TAKER_SUCCESS:
            return action.bookingGoodsTakerSuccess;
        default:
            return state;
    }
};

const bookingStatusError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_STATUS_ERROR:
            return action.bookingStatusError;
        default:
            return state;
    }
};

const bookingStatusLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_STATUS_LOADING:
            return action.bookingStatusLoading;
        default:
            return state;
    }
};

const bookingStatusSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_STATUS_SUCCESS:
            return action.bookingStatusSuccess;
        default:
            return state;
    }
};

const status = (state = [], action) => {
    switch (action.type) {
        case BOOKING_STATUS_SUCCESS:
            return action.status;
        default:
            return state;
    }
};

const statusOrderError = (state = false, action) => {
    switch (action.type) {
        case STATUS_ORDER_ERROR:
            return action.statusOrderError;
        default:
            return state;
    }
};

const statusOrderLoading = (state = false, action) => {
    switch (action.type) {
        case STATUS_ORDER_LOADING:
            return action.statusOrderLoading;
        default:
            return state;
    }
};

const statusOrderSuccess = (state = false, action) => {
    switch (action.type) {
        case STATUS_ORDER_SUCCESS:
            return action.statusOrderSuccess;
        default:
            return state;
    }
};

const statusOrder = (state = [], action) => {
    switch (action.type) {
        case STATUS_ORDER_SUCCESS:
            return action.statusOrder;
        default:
            return state;
    }
};

const bookingListError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_LIST_ERROR:
            return action.bookingListError;
        default:
            return state;
    }
};

const bookingListLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_LIST_LOADING:
            return action.bookingListLoading;
        default:
            return state;
    }
};

const bookingListSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_LIST_SUCCESS:
            return action.bookingListSuccess;
        default:
            return state;
    }
};

const PAYMENT_CHANNEL_BOOKING = "PAYMENT_CHANNEL_BOOKING";

const paymentChannelBookingLoading = (state = false, action) => {
    switch (action.type) {
        case PAYMENT_CHANNEL_BOOKING + "_LOADING":
            return action.loading;
        default:
            return state;
    }
};
const paymentChannelBookingError = (state = false, action) => {
    switch (action.type) {
        case PAYMENT_CHANNEL_BOOKING + "_ERROR":
            return action.error;
        default:
            return state;
    }
};
const paymentChannelBookingSuccess = (state = false, action) => {
    switch (action.type) {
        case PAYMENT_CHANNEL_BOOKING + "_SUCCESS":
            return action.success;
        default:
            return state;
    }
};
const paymentChannelBookingData = (state = [], action) => {
    switch (action.type) {
        case PAYMENT_CHANNEL_BOOKING + "_SUCCESS":
            return action.channel;
        default:
            return state;
    }
};

const BOOKING_PILIH_PEMBAYARAN = "BOOKING_PILIH_PEMBAYARAN";

const bookingPilihPembayaranLoading = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PILIH_PEMBAYARAN + "_LOADING":
            return action.loading;
        default:
            return state;
    }
};
const bookingPilihPembayaranSuccess = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PILIH_PEMBAYARAN + "_SUCCESS":
            return action.success;
        default:
            return state;
    }
};
const bookingPilihPembayaranError = (state = false, action) => {
    switch (action.type) {
        case BOOKING_PILIH_PEMBAYARAN + "_ERROR":
            return action.error;
        default:
            return state;
    }
};

const CEK_STATUS_PAYMENT_BOOKING = "CEK_STATUS_PAYMENT_BOOKING";

const cekStatusPaymentBookingLoading = (state = false, action) => {
    switch (action.type) {
        case CEK_STATUS_PAYMENT_BOOKING + "_LOADING":
            return action.loading;
        default:
            return state;
    }
};
const cekStatusPaymentBookingSuccess = (state = false, action) => {
    switch (action.type) {
        case CEK_STATUS_PAYMENT_BOOKING + "_SUCCESS":
            return action.success;
        default:
            return state;
    }
};
const cekStatusPaymentBookingError = (state = false, action) => {
    switch (action.type) {
        case CEK_STATUS_PAYMENT_BOOKING + "_ERROR":
            return action.error;
        default:
            return state;
    }
};

const initialState = {
    loading: false,
    success: false,
    error: false,
    payload: null,
};

const changeStatus = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_STATUS_BOOKING_LOADING:
            return {
                ...initialState,
                loading: action.loading,
            };
        case CHANGE_STATUS_BOOKING_SUCCESS:
            return {
                ...initialState,
                success: action.success,
                payload: action.payload,
            };
        case CHANGE_STATUS_BOOKING_ERROR:
            return {
                ...initialState,
                error: action.error,
            };
        case "CHANGE_STATUS_BOOKING_RESET":
            return initialState;
        default:
            return state;
    }
};

const bookingReducer = combineReducers({
    bookingPageError,
    bookingPageLoading,
    bookingPageSuccess,

    bookings,
    booking,

    bookingSaveError,
    bookingSaveLoading,
    bookingSaveSuccess,

    bookingViewError,
    bookingViewLoading,
    bookingViewSuccess,

    bookingRejectError,
    bookingRejectLoading,
    bookingRejectSuccess,

    bookingRejectDisnakError,
    bookingRejectDisnakLoading,
    bookingRejectDisnakSuccess,

    bookingApproveError,
    bookingApproveLoading,
    bookingApproveSuccess,

    bookingApproveDisnakError,
    bookingApproveDisnakLoading,
    bookingApproveDisnakSuccess,

    bookingPaymentConfirmationError,
    bookingPaymentConfirmationLoading,
    bookingPaymentConfirmationSuccess,

    bookingPaymentValidationError,
    bookingPaymentValidationLoading,
    bookingPaymentValidationSuccess,

    bookingROError,
    bookingROLoading,
    bookingROSuccess,

    bookingSIError,
    bookingSILoading,
    bookingSISuccess,

    bookingGenerateBLError,
    bookingGenerateBLLoading,
    bookingGenerateBLSuccess,

    bookingBLError,
    bookingBLLoading,
    bookingBLSuccess,

    bookingGoodsTakerError,
    bookingGoodsTakerLoading,
    bookingGoodsTakerSuccess,

    bookingStatusError,
    bookingStatusLoading,
    bookingStatusSuccess,
    status,

    statusOrderError,
    statusOrderLoading,
    statusOrderSuccess,
    statusOrder,

    bookingListError,
    bookingListLoading,
    bookingListSuccess,

    paymentChannelBookingLoading,
    paymentChannelBookingError,
    paymentChannelBookingSuccess,
    paymentChannelBookingData,

    bookingPilihPembayaranError,
    bookingPilihPembayaranLoading,
    bookingPilihPembayaranSuccess,

    cekStatusPaymentBookingLoading,
    cekStatusPaymentBookingError,
    cekStatusPaymentBookingSuccess,

    changeStatus,
});

export default bookingReducer;
